import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmApiPhoneUsedTooFrequentlyError extends TmApiValidationError {
  public name = 'TmApiPhoneUsedTooFrequentlyError'
}
